import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

/**
 * Icon tooltip
 * @param {string} tooltipText - Tooltip text describing the field
 */
const ClosableTooltip = ({ children, tooltipId }) => (
    <div className="tooltip tooltip--estima-address-field">
        {children}
        <ReactTooltip
            id={tooltipId}
            className="tooltip__panel tooltip__panel--estima-address-field"
            place="bottom"
            effect="solid"
        />
    </div>
);

ClosableTooltip.displayName = 'ClosableTooltip';

ClosableTooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

/**
 * Tooltip Functionnal Component
 */
export default ClosableTooltip;
